module.exports = __webpack_public_path__ + "static/img/partner_X.93f22d8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/partner_X.png
// module id = cvv7
// module chunks = 9